import axios from "axios";
import Config from '../../../config/config'
import {
    UPDATE_ROLEWITHPERMISSION_REQUEST,
    UPDATE_ROLEWITHPERMISSION_SUCCESS,
    UPDATE_ROLEWITHPERMISSION_ERROR,
    FETCH_ROLESWITHPERMISSIONBYID_REQUEST,
    FETCH_ROLESWITHPERMISSIONBYID_SUCCESS,
    FETCH_ROLESWITHPERMISSIONBYID_ERROR,
    CREATE_ROLESWITHPERMISSION_REQUEST,
    CREATE_ROLESWITHPERMISSION_SUCCESS,
    CREATE_ROLESWITHPERMISSION_ERROR,
    FETCH_ROLESWITHPERMISSION_REQUEST,
    FETCH_ROLESWITHPERMISSION_SUCCESS,
    FETCH_ROLESWITHPERMISSION_ERROR,
    UPDATE_PERMISSION_REQUEST,
    UPDATE_PERMISSION_SUCCESS,
    UPDATE_PERMISSION_ERROR,
    DELETE_PERMISSION_REQUEST,
    DELETE_PERMISSION_SUCCESS,
    DELETE_PERMISSION_ERROR,
    CREATE_PERMISSION_REQUEST, CREATE_PERMISSION_SUCCESS, CREATE_PERMISSION_ERROR,
    GET_PERMISSION_ERROR, GET_PERMISSION_REQUEST, GET_PERMISSION_SUCCESS
} from "../actiontypes";
import { notificationFail, notificationSuccess } from "../notificationMsg";
import history from "../../../utils/HistoryUtils";

export const getPermission = () => {
    const loggedInUser = localStorage.getItem('token').replace(/['"]+/g, '');
    return async (dispatch) => {
        dispatch(getPermissionRequest())
        await axios.get(`${Config.API_URL}api/organization/get-all-permission`, {
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${loggedInUser}`
            }
        }).then(response => {
            const data = response.data
            if (data.status === true) {
                dispatch(getPermissionSuccess(data))
            } else {
                dispatch(getPermissionError(data))
            }
        }).catch(error => {
            dispatch(getPermissionError(error))
        })
    }
}

export const getPermissionRequest = () => {
    return {
        type: GET_PERMISSION_REQUEST
    }
}
export const getPermissionSuccess = (data) => {
    return {
        type: GET_PERMISSION_SUCCESS,
        payload: data
    }
}
export const getPermissionError = (error) => {
    return {
        type: GET_PERMISSION_ERROR,
        payload: error
    }
}




export const genratePermission = (data) => {
    const loggedInUser = localStorage.getItem('token').replace(/['"]+/g, '');
    return async (dispatch) => {
        dispatch(createPermissionRequest())
        await axios.post(`${Config.API_URL}api/organization/create-permission`, data, {
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${loggedInUser}`
            }
        }).then(response => {
            const res = response.data;
            if (res.status === true) {
                dispatch(createPermissionSuccess(res))
                dispatch(notificationSuccess(res?.message))
                dispatch(getPermission())
                return true;
            } else {
                dispatch(createPermissionError(res));
                dispatch(notificationFail(res.message));

                return false;
            }
        }).catch(error => {
            const errorMessage = error?.response?.data?.message || 'Something went wrong';

            dispatch(createPermissionError(errorMessage))
            dispatch(notificationFail(errorMessage));
            return false;
        })
    }
}

export const createPermissionRequest = () => {
    return {
        type: CREATE_PERMISSION_REQUEST
    }
}
export const createPermissionSuccess = (data) => {
    return {
        type: CREATE_PERMISSION_SUCCESS,
        payload: data
    }
}
export const createPermissionError = (error) => {
    return {
        type: CREATE_PERMISSION_ERROR,
        payload: error
    }
}


export const updatePermission = (data) => {
    const loggedInUser = localStorage.getItem('token')?.replace(/['"]+/g, '');
    return async (dispatch) => {
        dispatch(updatePermissionRequest());
        try {
            const response = await axios.post(`${Config.API_URL}api/organization/updates-permission`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loggedInUser}`
                }
            });
            const resData = response.data;
            console.log(resData, "resData");
            if (resData.status === true) {
                dispatch(updatePermissionSuccess(resData.data));
                dispatch(notificationSuccess(resData.message));
                dispatch(getPermission());
            } else {
                dispatch(updatePermissionError(resData.message));
                dispatch(notificationFail(resData.message));
            }
        } catch (error) {
            console.error("Error is there:", error);
            const errorMessage = error?.response?.data?.message || 'Something went wrong';
            dispatch(updatePermissionError(errorMessage));
            dispatch(notificationFail(errorMessage));
        }
    };
};

export const updatePermissionRequest = () => {
    return {
        type: UPDATE_PERMISSION_REQUEST
    }
}
export const updatePermissionSuccess = (data) => {
    return {
        type: UPDATE_PERMISSION_SUCCESS,
        payload: data
    }
}
export const updatePermissionError = (error) => {
    return {
        type: UPDATE_PERMISSION_ERROR,
        payload: error
    }
}



export const deletePermission = (role_id) => {
    const loggedInUser = localStorage.getItem('token').replace(/['"]+/g, '');
    return async (dispatch) => {
        dispatch(deletePermissionRequest())
        await axios.delete(`${Config.API_URL}api/organization/permission-delete/${role_id}`, {
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${loggedInUser}`
            }
        }).then(response => {
            const data = response.data
            if (data.status === true) {
                dispatch(deletePermissionSuccess(data))
                dispatch(notificationSuccess(data.message))
                setTimeout(() => {
                    dispatch(getPermission())
                }, 2000);
            } else {
                dispatch(deletePermissionError(data.message))
                dispatch(notificationFail(data.message))
            }
        }).catch(error => {
            dispatch(deletePermissionError(error.response.data))
            dispatch(notificationFail(error.response.data))
        })
    }
}

export const deletePermissionRequest = () => {
    return {
        type: DELETE_PERMISSION_REQUEST
    }
}
export const deletePermissionSuccess = (data) => {
    return {
        type: DELETE_PERMISSION_SUCCESS,
        payload: data
    }
}
export const deletePermissionError = (error) => {
    return {
        type: DELETE_PERMISSION_ERROR,
        payload: error
    }
}



export const assignPermissionToRole = (data) => {
    const loggedInUser = localStorage.getItem('token')?.replace(/['"]+/g, '');
    return async (dispatch) => {
        dispatch(assignPermissiontoRoleRequest());
        try {
            const response = await axios.post(
                `${Config.API_URL}api/organization/assignPermission-to-role`, 
                data, 
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${loggedInUser}`
                    }
                }
            );
            
            const resData = response.data;
            if (resData.status === true) {
                dispatch(assignPermissiontoRoleSuccess(resData));
                dispatch(notificationSuccess(resData.message || 'Permissions assigned successfully'));
                return { success: true, data: resData };
            } else {
                const errorMsg = resData.message || 'Failed to assign permissions';
                dispatch(assignPermissiontoRoleError(errorMsg));
                dispatch(notificationFail(errorMsg));
                return { success: false, error: errorMsg };
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'Something went wrong';
            dispatch(assignPermissiontoRoleError(errorMessage));
            dispatch(notificationFail(errorMessage));
            return { success: false, error: errorMessage };
        }
    };
};

export const assignPermissiontoRoleRequest = () => {
    return {
        type: CREATE_ROLESWITHPERMISSION_REQUEST
    }
}
export const assignPermissiontoRoleSuccess = (data) => {
    return {
        type: CREATE_ROLESWITHPERMISSION_SUCCESS,
        payload: data
    }
}
export const assignPermissiontoRoleError = (error) => {
    return {
        type: CREATE_ROLESWITHPERMISSION_ERROR,
        payload: error
    }
}


export const fetchRolesWithPermission = () => {
    const loggedInUser = localStorage.getItem('token')?.replace(/['"]+/g, '');
    return async (dispatch) => {
        dispatch(fetchRolesWithPermissionRequest());
        try {
            const response = await axios.get(`${Config.API_URL}api/organization/get-roleWith-permission`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loggedInUser}`
                }
            });
            const resData = response.data;
            console.log(resData, "resData");
            if (resData.status === true) {
                dispatch(fetchRolesWithPermissionSuccess(resData));
                // dispatch(notificationSuccess(resData.message));
            } else {
                dispatch(assignPermissiontoRoleError(resData));
                // dispatch(notificationFail(resData));
            }
        } catch (error) {
            console.error("Error is there:", error);
            const errorMessage = error?.response?.data?.message || 'Something went wrong';
            dispatch(fetchRolesWithPermissionError(errorMessage));
            dispatch(notificationFail(errorMessage));
        }
    };
};

export const fetchRolesWithPermissionRequest = () => {
    return {
        type: FETCH_ROLESWITHPERMISSION_REQUEST
    }
}
export const fetchRolesWithPermissionSuccess = (data) => {
    return {
        type: FETCH_ROLESWITHPERMISSION_SUCCESS,
        payload: data
    }
}
export const fetchRolesWithPermissionError = (error) => {
    return {
        type: FETCH_ROLESWITHPERMISSION_ERROR,
        payload: error
    }
}


export const fetchRolesWithPermissionById = (id) => {
    const loggedInUser = localStorage.getItem('token')?.replace(/['"]+/g, '');
    return async (dispatch) => {
        dispatch(fetchRolesWithPermissionByIdRequest());
        try {
            const response = await axios.get(`${Config.API_URL}api/organization/fetchRole-with-permission/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loggedInUser}`
                }
            });
            const resData = response.data;
            if (resData.status === true) {
                dispatch(fetchRolesWithPermissionByIdSuccess(resData));
                dispatch(notificationSuccess(resData.message));
            } else {
                dispatch(assignPermissiontoRoleError(resData.message));
                dispatch(notificationFail(resData.message));
            }
        } catch (error) {
            console.error("Error is there:", error);
            const errorMessage = error?.response?.data?.message || 'Something went wrong';
            dispatch(fetchRolesWithPermissionByIdError(errorMessage));
            dispatch(notificationFail(errorMessage));
        }
    };
};

export const fetchRolesWithPermissionByIdRequest = () => {
    return {
        type: FETCH_ROLESWITHPERMISSIONBYID_REQUEST
    }
}
export const fetchRolesWithPermissionByIdSuccess = (data) => {
    return {
        type: FETCH_ROLESWITHPERMISSIONBYID_SUCCESS,
        payload: data
    }
}
export const fetchRolesWithPermissionByIdError = (error) => {
    return {
        type: FETCH_ROLESWITHPERMISSIONBYID_ERROR,
        payload: error
    }
}

export const updateRolesandPermission = (data) => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    return async (dispatch) => {
        dispatch(updateRolesWithPermissionRequest());
        try {
            const response = await axios.post(
                `${Config.API_URL}api/organization/updateRoles-with-permission`, 
                data, 
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + loggedInUser,
                    },
                }
            );
            
            const responseData = response.data;
            if (responseData && responseData.status === true) {
                dispatch(updateRolesWithPermissionSuccess(responseData));
                dispatch(notificationSuccess(responseData?.message));
                dispatch(fetchRolesWithPermission());
                return { success: true, data: responseData };
            } else {
                const errorMsg = responseData?.message || 'Failed to update permissions';
                dispatch(updateRolesWithPermissionError(errorMsg));
                dispatch(notificationFail(errorMsg));
                return { success: false, error: errorMsg };
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'Something went wrong';
            dispatch(updateRolesWithPermissionError(errorMessage));
            dispatch(notificationFail(errorMessage));
            return { success: false, error: errorMessage };
        }
    };
};

const updateRolesWithPermissionRequest = () => {
    return {
        type: UPDATE_ROLEWITHPERMISSION_REQUEST,
    };
};

const updateRolesWithPermissionSuccess = (data) => {
    return {
        type: UPDATE_ROLEWITHPERMISSION_SUCCESS,
        payload: data,
    };
};

const updateRolesWithPermissionError = (error) => {
    return {
        type: UPDATE_ROLEWITHPERMISSION_ERROR,
        payload: error,
    };
};


export const deleteRoleWithPermission = (role_id) => {
    const loggedInUser = localStorage.getItem('token').replace(/['"]+/g, '');
    return async (dispatch) => {
        dispatch(deletePermissionRequest())
        await axios.delete(`${Config.API_URL}api/organization/delete-role-with-permission/${role_id}`, {
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${loggedInUser}`
            }
        }).then(response => {
            const data = response.data
            if (data.status === true) {
                dispatch(deletePermissionSuccess(data))
                dispatch(notificationSuccess(data.message))
                dispatch(fetchRolesWithPermission())
            } else {
                dispatch(deletePermissionError(data.message))
                dispatch(notificationFail(data.message))
            }
        }).catch(error => {
            dispatch(deletePermissionError(error.response.data))
            dispatch(notificationFail(error.response.data))
        })
    }
}
